import { Center, Checkbox, Spinner, Stack } from '@chakra-ui/core';
import React from 'react';
import { BusinessPositionQueryParamsT, BusinessPositionT, BusinessT } from '../../calendar/types';
import { useStoreActions } from '../../../models/hooks';

interface Props {
  business: BusinessT;
  isActive: boolean;
  onCheckChange: (position: BusinessPositionT) => void;
}

export default function PositionByBusinnessList({ business, isActive, onCheckChange }: Props) {
  const fetchBusinessPositions = useStoreActions((state) => state.calendar.fetchBusinessPositions);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);

  const [positions, setPositions] = React.useState<BusinessPositionT[]>([]);

  const defaultQueryParams: BusinessPositionQueryParamsT = {
    page: 1,
    // limit: 10,
    sortBy: 'createdAt',
    sortOrder: 'asc',
  };
  const [queryParams] = React.useState<BusinessPositionQueryParamsT>(defaultQueryParams);

  React.useEffect(
    () => {
      if (!isActive) return;
      if (positions.length > 0) {
        setIsFetching(true);
      } else {
        setIsLoading(true);
      }
      fetchBusinessPositions({ businessId: business.id, queryParams })
        .then((res) => {
          setPositions(res.data.data);
        })
        .finally(() => {
          setIsLoading(false);
          setIsFetching(false);
        });
    },
    // eslint-disable-next-line
    [business, queryParams, isActive],
  );

  if (isLoading) {
    return (
      <Center paddingY={3}>
        <Spinner thickness="1px" speed="0.65s" color="blue.500" size="sm" />
      </Center>
    );
  }

  return (
    <>
      <Stack className="location-wise-position-stack" pt={3} borderTopWidth="1px" borderTopColor="gray.100" spacing={[1, 2]}>
        {positions.map((position, index) => {
          return (
            <Checkbox
              d="flex"
              colorScheme="blue"
              key={position.id}
              data-testid={`Checkbox-${position.id}`}
              value={position.id}
              mb={positions.length === index + 1 ? '3' : '0'}
              onChange={() => {
                onCheckChange(position);
              }}
            >
              {position.customName}
            </Checkbox>
          );
        })}
        {isFetching && (
          <Center paddingY={3}>
            <Spinner thickness="1px" speed="0.65s" color="blue.500" size="sm" />
          </Center>
        )}
      </Stack>
    </>
  );
}
